import { defineProvider } from '@nuxt/image/runtime';
import { getAssetURL } from '~/utils/assets';

interface MonospaceProviderOptions {
	baseURL: string;
	modifiers?: {
		project?: string;
	};
}

export default defineProvider<MonospaceProviderOptions>({
	getImage(src: string, { baseURL, modifiers }) {
		const { project } = modifiers ?? {};

		return {
			url: getAssetURL(src, { apiBase: baseURL, projectSlug: project }),
		};
	},
});
